import { observer } from 'mobx-react-lite';
import Sticky from '@client/uikit/Sticky';
import { CommonLink } from '@client/component/CommonLink';
import { ChevronRightIcon } from 'lucide-react';
import { SecurityResponse } from '../../../../response/responseSchema';

const TopHoldingStickyLabel = observer(
    ({ security, institutionSlug }: { security?: SecurityResponse; institutionSlug: string }) => {
        if (!security) {
            return null;
        }

        const securityName = security.stock?.nameKo || security.stock?.name || security.name;
        const ticker = security.stock?.ticker;

        return (
            <Sticky className="bg-base-100 border-base-300 -mx-5 flex flex-row items-center justify-between gap-1 border-b px-5 py-3">
                <div className="flex flex-col">
                    <div className="text-primary truncate text-base font-semibold tracking-tight">
                        {securityName} {ticker && `(${ticker})`}
                    </div>
                </div>
                <CommonLink
                    to={`/portfolio/${institutionSlug}/security/${security.hash}`}
                    className="btn btn-xs btn-soft btn-primary justify-between gap-0.5"
                >
                    자세히
                    <ChevronRightIcon className="size-3" />
                </CommonLink>
            </Sticky>
        );
    },
);

export default TopHoldingStickyLabel;
